import { useQuery } from "@tanstack/react-query";
import { isSameDay, parse } from "date-fns";
import React from "react";
import { useParams } from "react-router-dom";
import SwiperCore from "swiper";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Employee, { type EmployeeProp } from "./Employee";
import LocationView from "./LocationView";
import MenuView from "./MenuView";
import MonthView from "./MonthView";
import TodayView from "./TodayView";
import WeekView from "./WeekView";
import getLocationSlug, { legend, wakefieldLegend } from "./utils/getLocationSlug";
import useSheets from "./utils/useSheets";

SwiperCore.use([Autoplay]);

function Main(props) {
  const match = useParams<{ community: string; wing: string }>();
  const wing = match.wing;
  const { events, today } = useSheets({ view: "today" });
  const optionsQuery = useQuery({
    queryKey: ["options", match.community],
    queryFn: async () => {
      const res = await fetch(`https://calyxseniorliving.com/wp-json/options/all`);
      const json = await res.json();
      return json;
    },
  });
  const employee1: EmployeeProp = optionsQuery.data?.[match.community];
  const employee2: EmployeeProp = optionsQuery.data?.[`${match.community}_2`];

  // console.log("employee", employee);

  if (events.length === 0) {
    // return null;
  }

  const locations = ["center", "outdoor", "a-wing", "b-wing", "c-wing", "d-wing"];

  let communityLegend = legend;

  if (match.community === "wakefield" || match.community === "apex") {
    communityLegend = wakefieldLegend;
  }

  return (
    <div className={match.community}>
      <Swiper
        autoplay={{
          delay: 15 * 1000,
        }}
        loop
      >
        {!wing && (
          <SwiperSlide key="week">
            <div className="view">
              <WeekView />
            </div>
          </SwiperSlide>
        )}

        <SwiperSlide key="menu">
          <div className="view">
            <MenuView />
          </div>
        </SwiperSlide>

        {!wing && (
          <SwiperSlide key="today">
            <div className="view">
              <TodayView />
            </div>
          </SwiperSlide>
        )}

        {wing && (
          <SwiperSlide key={wing}>
            <div className="view">
              <LocationView location={wing} />
            </div>
          </SwiperSlide>
        )}

        {wing && (
          <SwiperSlide key="week">
            <div className="view">
              <WeekView location={wing} />
            </div>
          </SwiperSlide>
        )}

        {!wing &&
          locations
            .filter((w) => {
              const locationEvents = events.filter((e) => {
                const eventDate = parse(e["Event-Date"], "M/d/yy", new Date());
                const eventLocationSlug = getLocationSlug(e["Event-Location"], match.community);

                // console.log("eventLocationSlug", eventLocationSlug);

                return (
                  isSameDay(eventDate, today) &&
                  (w === eventLocationSlug ||
                    communityLegend[w].rooms.includes(e["Event-Location"]))
                );
              });

              return locationEvents.length > 0;
            })
            .map((w) => {
              return (
                <SwiperSlide key={w}>
                  <div className="view">
                    <LocationView location={w} />
                  </div>
                </SwiperSlide>
              );
            })}

        {employee1?.include_in_rotation && (
          <SwiperSlide key="employee">
            <div className="view">
              <Employee employee={employee1} />
            </div>
          </SwiperSlide>
        )}

        {employee2?.include_in_rotation && (
          <SwiperSlide key="employee2">
            <div className="view">
              <Employee employee={employee2} />
            </div>
          </SwiperSlide>
        )}

        <SwiperSlide key="month">
          <div className="view">
            <MonthView />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Main;
